import { all, call, fork, takeLatest } from 'redux-saga/effects';
import { closeSidePanelOnUnmountFlow, getVisitConfig, fetchVisitFlow, visitsFlow } from './visits/saga';
import { getAllProviders, providerLocationHistoryFlow, providerSchedulesFlow, providersSearchFlow } from './providers/saga';
import { claimsFlow } from './claim/saga';
import { dashboardFlow } from './dashboard/saga';
import { feeScheduleFlow } from './fee-schedule/saga';
import { getMarkets } from './markets/saga';
import { getServiceOfferingList } from './service-offering/saga';
import { onSiteManagerFlow } from './on-site-manager/saga';
import { patientNotesFlow } from './patient-notes/saga';
import { patientsSearchFlow } from './patients/saga';
import { schedulingFlow } from './scheduling/saga';
import { timeSlotsForUpdateTimeFlow } from './on-site-manager/on-site-visits/saga';
import { toastMessageFlow } from './message/saga';
import { patientFilesFlow } from './patient-files/saga';
import { marketMapFlow } from './market-map/saga';
import { getActiveUser } from './auth/saga';
import { agenciesFlow, getAgencies } from './concierge/saga';

function* fetchSeedData() {
  try {
    yield all([fork(getActiveUser), fork(getMarkets), fork(getAllProviders), fork(getServiceOfferingList), fork(getVisitConfig), fork(getAgencies)]);
  } catch (e: any) {
    // error handling
  }
}

function* onAppLoadFlow() {
  yield takeLatest('AUTH_LOGIN_SUCCESS', fetchSeedData);
}

export function* rootSaga() {
  yield all([
    // Pages...
    call(dashboardFlow),
    call(visitsFlow),
    call(fetchVisitFlow),
    call(claimsFlow),
    call(feeScheduleFlow),
    call(onSiteManagerFlow),
    call(schedulingFlow),
    call(closeSidePanelOnUnmountFlow),

    // Searching input change sagas
    call(patientsSearchFlow),
    call(patientNotesFlow),
    call(patientFilesFlow),
    call(providersSearchFlow),
    call(providerSchedulesFlow),
    call(providerLocationHistoryFlow),
    call(timeSlotsForUpdateTimeFlow),

    call(toastMessageFlow),
    call(agenciesFlow),
    call(marketMapFlow),

    // Seed data for the application..
    // Be mindful, this should be one time date for the life of app...
    call(onAppLoadFlow),
  ]);
}
